export default {
  getAssigned: ({ offset, limit = 20 }) => `/carrier/orders?filter_by=assigned&offset=${offset * limit}&limit=${limit}`,
  putAssigned: '/carrier/orders/update',
  getReady: ({ offset, limit = 20 }) => `/carrier/orders?filter_by=delivered&offset=${offset * limit}&limit=${limit}`
}
